export enum Roles {
  WEBRQA_USER = 'webrqa_user',
  WEBRQA_DRAW = 'webrqa_draw',
  WEBRQA_VIEWER = 'webrqa_viewer',
  WEBRQA_OBSERVER = 'webrqa_observer'
}
